module.exports = __webpack_public_path__ + "img/170004.105339f2.png";